const c = {
  name: "Boston",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,0H3v10.8c0,0.6,0.1,1.2,0.2,1.8c0.2,0.9,0.7,1.7,1.2,2.5c0.1,0.1,0.1,0.1,0.2,0.2L6,16.9l0,0l4.2,5.1l0,0
			l0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.5,0.5,1.1,0.9,1.7,1.1c0.2,0.1,0.3,0.1,0.5,0.2c0.5,0.2,1,0.3,1.5,0.3c1.4,0,2.8-0.4,3.8-1.3
			c1-0.9,1.7-2.1,1.9-3.4c0.2-1.3-0.1-2.7-0.8-3.9L19,15l0,0c0,0-0.1-0.1-0.1-0.1L14,9V0z M6,2v2H5V2H6z M5,6h7v3.8l4.6,5.5
			c-1.2,0.3-2.3,0.9-3.3,1.7c-1,0.8-1.8,1.8-2.3,2.9l-3-3.6c0.6-1,1-2.1,1-3.3l-1,0l1,0c0-1.4-0.5-2.7-1.4-3.8C6.9,8.3,6,7.7,5,7.3
			V6z M8,4V2h1v2H8z M11,2h1v2h-1V2z M13.6,22c-0.2,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.2-0.6-0.4c0.4-1.1,1.2-2.1,2.1-2.9
			c0.9-0.8,2.1-1.3,3.3-1.5c0.3,0.6,0.4,1.3,0.3,2c-0.1,0.9-0.6,1.6-1.2,2.2l0,0c-0.7,0.6-1.6,0.9-2.5,0.9
			C14.1,22.1,13.9,22.1,13.6,22z M5,9.5c0.4,0.2,0.8,0.6,1.1,0.9C6.7,11.2,7,12.1,7,13c0,0.6-0.1,1.1-0.3,1.6L6.2,14
			c-0.1-0.1-0.2-0.2-0.3-0.3C5.3,12.8,5,11.9,5,10.8V9.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Boston
};
